import { apiClient } from "./authService";

export interface BannerPayload {
  title: string;
  description?: string;
  order?: number;
  imageUrl?: string;
  isActive?: boolean;
}

type BannerId = string | number;

const buildFormData = (
  payload: BannerPayload,
  file?: File | Blob | null
): FormData => {
  const formData = new FormData();

  const entries: [string, any][] = [
    ["title", payload.title],
    ["description", payload.description],
    ["order", payload.order !== undefined ? String(payload.order) : undefined],
    ["isActive", payload.isActive],
    ["imageUrl", payload.imageUrl],
  ];

  entries.forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      if (value instanceof Blob) {
        formData.append(key, value);
      } else if (typeof value === "boolean") {
        formData.append(key, value ? "true" : "false");
      } else {
        formData.append(key, String(value));
      }
    }
  });

  if (file) {
    formData.append("image", file);
  }

  return formData;
};

// ADMIN: List all banners
export const fetchBanners = async () => {
  try {
    const response = await apiClient.get("/banners/all");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PUBLIC/MOBILE: List active banners only
export const fetchActiveBanners = async () => {
  try {
    const response = await apiClient.get("/banners/all/active");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createBanner = async (
  payload: BannerPayload,
  file?: File | Blob | null
) => {
  try {
    const formData = buildFormData(payload, file);
    const response = await apiClient.post("/banners/create", formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBanner = async (
  id: BannerId,
  payload: BannerPayload,
  file?: File | Blob | null
) => {
  try {
    if (!id && id !== 0) {
      throw new Error("Banner ID is required.");
    }
    const formData = buildFormData(payload, file);
    const response = await apiClient.patch(`/banners/update/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleBanner = async (id: BannerId) => {
  try {
    if (!id && id !== 0) {
      throw new Error("Banner ID is required.");
    }
    const response = await apiClient.patch(`/banners/${id}/toggle`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBanner = async (id: BannerId) => {
  try {
    if (!id && id !== 0) {
      throw new Error("Banner ID is required.");
    }
    const response = await apiClient.delete(`/banners/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
